import { useCallback } from "react";
import { Skeleton } from "@crehana/compass.ui";
import { useCatalogEmptyStateContext } from "../context";
import { useCatalogEmptyStateTranslations } from "../hooks";
import { CategoryChip } from "../ui";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var CategoryChips = function CategoryChips() {
  var _useCatalogEmptyState = useCatalogEmptyStateContext(),
    selectedCategory = _useCatalogEmptyState.selectedCategory,
    allCategories = _useCatalogEmptyState.allCategories,
    isLoadingAllCategories = _useCatalogEmptyState.isLoadingAllCategories,
    selectCategory = _useCatalogEmptyState.selectCategory;
  var _useCatalogEmptyState2 = useCatalogEmptyStateTranslations(),
    t = _useCatalogEmptyState2.t;
  var onSelectedChange = useCallback(function (selected) {
    return function () {
      selectCategory(selected);
    };
  }, [selectCategory]);
  return /*#__PURE__*/_jsx("div", {
    className: "tw-flex tw-flex-wrap tw-mb-2",
    role: "grid",
    "aria-live": isLoadingAllCategories ? 'polite' : undefined,
    children: isLoadingAllCategories ? Array.from({
      length: 6
    }).map(function (_, index) {
      return /*#__PURE__*/_jsx(Skeleton, {
        className: "tw-w-8 tw-h-3.2 tw-mr-0.8 tw-rounded-2",
        animated: true
      }, index);
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(CategoryChip, {
        label: t('CATALOG_EMPTY_STATE_CHIP_ALL'),
        selected: !selectedCategory
        // 'undefined' is used to clear the selection and then 'Todos' is selected.
        ,

        onClick: onSelectedChange(undefined)
      }), allCategories.map(function (option) {
        var isSelectedOption = (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.id) === option.id;
        return /*#__PURE__*/_jsx(CategoryChip, {
          label: option.label,
          selected: isSelectedOption,
          onClick: onSelectedChange(option)
        }, option.label);
      })]
    })
  });
};
export default CategoryChips;